function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import { SelectedIndicator } from './styles';
/**
 * PaginationSelectedIndicator
 *
 * This component holds some state that's derived
 * based on the difference of selectedIndex from the
 * last render—if the difference is greater than 1,
 * automatically transition the indicator with easing.
 *
 * If the difference is less than 1, we assume that
 * the Pagination is being controlled continuously (for
 * swipe/scroll animations, for instance). If that's
 * that case, we set shouldTransition to false so that
 * the transformation occurs instantaneously.
 */

var PaginationSelectedIndicator =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PaginationSelectedIndicator, _React$Component);

  function PaginationSelectedIndicator() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PaginationSelectedIndicator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PaginationSelectedIndicator)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      shouldTransition: true
    });

    return _this;
  }

  _createClass(PaginationSelectedIndicator, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var difference = Math.abs(nextProps.selectedIndex - this.props.selectedIndex);
      this.setState({
        shouldTransition: difference >= 1
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(SelectedIndicator, _extends({}, this.props, {
        shouldTransition: this.state.shouldTransition
      }));
    }
  }]);

  return PaginationSelectedIndicator;
}(React.Component);

_defineProperty(PaginationSelectedIndicator, "propTypes", {
  selectedIndex: PropTypes.number
});

export default PaginationSelectedIndicator;